import React from 'react';
import { Text } from '@carnica/ui-kit';
import { useIsMobileDimension } from '@carnica/utils/hooks';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
import { TARIFF_TEXTS } from "../../constants/tariff";
import { getNextBillingDate } from "../../utils";
var cn = classNames.bind(styles);
export var BillingDate = function BillingDate(_ref) {
  var billingDate = _ref.billingDate,
    _ref$isComposeBilling = _ref.isComposeBillingDate,
    isComposeBillingDate = _ref$isComposeBilling === void 0 ? false : _ref$isComposeBilling;
  var isMobile = useIsMobileDimension();
  var nextBillingDate = isComposeBillingDate ? getNextBillingDate(billingDate, false) : billingDate;
  return /*#__PURE__*/React.createElement(Text, {
    className: cn('text'),
    color: "secondary",
    variant: isMobile ? 'caption-medium' : 'body-small',
    "data-t-id": "components-BillingDate"
  }, TARIFF_TEXTS.defaultNextBillingDateText, " ", nextBillingDate);
};